class ManciniProcedurePage extends HTMLElement {
  connectedCallback() {
    if (this.dataset.manciniReady === 'true') return;

    this.dataset.manciniReady = 'true';
    this.classList.add('mancini-procedure--enhanced');
    this.abortController = new AbortController();
    this.#initializeProcessTabs();
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  #initializeProcessTabs() {
    const tabInterface = this.querySelector('[data-procedure-tabs]');
    if (!tabInterface) return;

    const tabList = tabInterface.querySelector('.mancini-procedure-hub__process-tabs');
    const tabs = [...tabInterface.querySelectorAll('[data-procedure-tab]')];
    const panels = [...tabInterface.querySelectorAll('[data-procedure-panel]')];
    if (!tabList || tabs.length === 0 || tabs.length !== panels.length) return;

    tabList.setAttribute('role', 'tablist');
    tabList.setAttribute('aria-orientation', 'horizontal');

    const activateTab = (activeIndex, moveFocus = false) => {
      tabs.forEach((tab, index) => {
        const isActive = index === activeIndex;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panels[index].id);
        tab.setAttribute('aria-selected', String(isActive));
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
        if (isActive) tab.setAttribute('aria-current', 'step');
        else tab.removeAttribute('aria-current');
        tab.classList.toggle('is-active', isActive);

        panels[index].setAttribute('role', 'tabpanel');
        panels[index].tabIndex = 0;
        panels[index].hidden = !isActive;
      });

      if (moveFocus) tabs[activeIndex].focus();
    };

    activateTab(0);

    tabs.forEach((tab, index) => {
      tab.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          activateTab(index);
        },
        { signal: this.abortController.signal }
      );

      tab.addEventListener(
        'keydown',
        (event) => {
          let nextIndex = null;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex === null) return;

          event.preventDefault();
          activateTab(nextIndex, true);
        },
        { signal: this.abortController.signal }
      );
    });
  }
}

if (!customElements.get('mancini-procedure-page')) {
  customElements.define('mancini-procedure-page', ManciniProcedurePage);
}
